import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { daysRemainingUntil } from "./revenue/revenueModel";
import { RevenueHeader } from "./revenue/RevenueHeader";
import { RevenueGauge, RevenueBreakdown, RevenueTrendChart } from "./revenue/RevenuePanels";

const UnifiedRevenueDashboard = ({ goal, current, progressPercentage, goalEndDate, instanceName }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const daysRemaining = daysRemainingUntil(goalEndDate);

  return (
    <motion.div className="glass-card card-3d cursor-pointer overflow-hidden relative" onMouseEnter={() => setIsExpanded(true)} onMouseLeave={() => setIsExpanded(false)}
      onClick={() => setIsExpanded(!isExpanded)} data-testid="unified-revenue-dashboard" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} layout>
      <div className="absolute inset-0 opacity-30 pointer-events-none"><div className="absolute inset-0 bg-gradient-to-br from-ism-teal/10 via-transparent to-ism-teal/5" /></div>
      <div className="absolute inset-0 rounded-xl opacity-50 pointer-events-none holo-border" />

      <div className="p-5 sm:p-8 relative z-10">
        <RevenueHeader goal={goal} progressPercentage={progressPercentage} goalEndDate={goalEndDate} daysRemaining={daysRemaining} instanceName={instanceName} isExpanded={isExpanded} />
        <AnimatePresence>
          {isExpanded && (
            <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} transition={{ duration: 0.4, ease: "easeInOut" }} data-testid="revenue-expanded">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-6">
                <RevenueGauge progressPercentage={progressPercentage} />
                <RevenueBreakdown current={current} remaining={goal - current} progressPercentage={progressPercentage} />
                <RevenueTrendChart />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default UnifiedRevenueDashboard;
